import $ from 'jquery';

export const scrollToSection = () => {

    const $btn = $('.js-btn-scroll');
        
    $btn.on('click', function(e) {

        if (this.hash !== '') {

            e.preventDefault();
            
            const hash = this.hash;

            $('html, body').animate({ scrollTop: $(hash).offset().top }, 600, function() {
                // Update the url hash
                if (history.pushState) {
                    const urlHash = hash;
                    history.pushState(null, null, urlHash);
                }
            });
        }
    });
};